var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7283 4.83583C11.9112 4.78797 12.1034 4.78806 12.2862 4.83609C12.4522 4.87968 12.6323 4.99425 13.3824 5.55445L19.5553 10.1648C19.9535 10.4622 20.5175 10.3805 20.8149 9.98224C21.1124 9.58399 21.0306 9.02004 20.6324 8.7226L14.4595 4.11228L14.3447 4.0264C13.7738 3.59887 13.2944 3.23984 12.7435 3.09515C12.2614 2.96851 11.7548 2.96828 11.2726 3.09447C10.7216 3.23865 10.2419 3.59724 9.67057 4.02424L9.55571 4.11001L3.36847 8.7221C2.96995 9.01917 2.8877 9.58305 3.18476 9.98157C3.48183 10.3801 4.04571 10.4623 4.44423 10.1653L10.6315 5.55318C11.3821 4.99367 11.5623 4.87927 11.7283 4.83583ZM12.9001 10.8906C12.9001 10.3935 12.4972 9.99059 12.0001 9.99059C11.503 9.99059 11.1001 10.3935 11.1001 10.8906V19.1004H8.9001V10.8929C8.9001 10.3959 8.49715 9.99291 8.0001 9.99291C7.50304 9.99291 7.1001 10.3959 7.1001 10.8929V19.1004H3.90244C3.40538 19.1004 3.00244 19.5033 3.00244 20.0004C3.00244 20.4974 3.40538 20.9004 3.90244 20.9004H20.0978C20.5948 20.9004 20.9978 20.4974 20.9978 20.0004C20.9978 19.5033 20.5948 19.1004 20.0978 19.1004H16.9001V10.8929C16.9001 10.3959 16.4972 9.99291 16.0001 9.99291C15.503 9.99291 15.1001 10.3959 15.1001 10.8929V19.1004H12.9001V10.8906Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankOutline);
export default __webpack_public_path__ + "static/media/bank_outline.ab7111d1d6d4cda02fd5d3320d1caca8.svg";
export { ForwardRef as ReactComponent };